import React, { useEffect, useState } from 'react'
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  UncontrolledTooltip,
  Form,
  FormGroup,
  CardBody,
  Label,
  Input,
  CardHeader
} from 'reactstrap'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { compose } from 'redux'
import _ from 'lodash'

import PageTitle from 'components/Title/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import ArkPagination from 'components/Pagination'
import AlertNotSubscribe from 'components/Alert'
import RecipientGroupHOC from './actions'
import Create from './Create'
import Update from './Update'
import View from './View'

import { convertSearchObjectToBase64 } from 'utils/objToBase64'
import Lang from 'Lang/General'

const RecipientGroupListings = props => {
  const [ subscribedPackage, setSubscribePackage ] = useState( true )

  useEffect( () => {
    props.getAllRecipientGroup( convertSearchObjectToBase64({ is_paginated: true, page: 1 }) )
    let tmpIndex = _.findIndex( props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Marketing Funnel' })
    setSubscribePackage( tmpIndex > -1 )
  }, [])

  return (
    <>
      <PageTitle
        heading={ Lang[ 'FUNNEL_GROUPS' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
        icon="pe-7s-news-paper icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: Lang[ 'CREATE_RECIPIENT_GROUP' ][ props.data.languageReducer.userSettings.admin_panel_language ],
            onClick: () => {
              props.onChangeRecipientGroupHOC('showCreateRecipientGroup', true )
            },
            display: false
          }
        ]}
         />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={ true }
        transitionAppearTimeout={ 0 }
        transitionEnter={ false }
        transitionLeave={ false }>
        <Container fluid>
          {
            !subscribedPackage && (
              <AlertNotSubscribe { ...props } />
            )
          }
          <Row>
            <Col md={ 12 }>
              <Card className="main-card mb-3">
                <CardHeader>{ Lang[ 'SEARCH' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</CardHeader>
                <CardBody>
                  <Form onSubmit={ e => e.preventDefault()}>
                    <FormGroup>
                      <Label>{ Lang[ 'NAME' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Label>
                      <Input
                        type={ 'text' }
                        value={ props.searchParams[0].param }
                        onChange={ e => {
                          let tmp = _.cloneDeep( props.searchParams )
                          tmp[ 0 ][ 'param' ] = e.target.value
                          return props.onChangeRecipientGroupHOC( 'searchParams', tmp )
                        }} />
                    </FormGroup>
                    <div className="d-flex">
                      <Button
                        color="primary"
                        style={{ marginLeft: 'auto' }}
                        onClick={() => {
                          let tmp = {
                            is_paginated: true,
                            page: 1,
                            filter: {
                              name: {
                                $like: `%${props.searchParams[0].param}%`
                              }
                            }
                          }
                          props.getAllRecipientGroup( convertSearchObjectToBase64(tmp) )
                        }}>{ Lang[ 'SEARCH' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Button>
                      <Button
                        color="danger"
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          let tmp = [
                            {
                              label: 'Name',
                              value: 'name',
                              param: ''
                            }
                          ]
                          props.onChangeRecipientGroupHOC( 'searchParams', tmp )
                          props.getAllRecipientGroup( convertSearchObjectToBase64({ page: 1, is_paginated: true }) )
                        }}>{ Lang[ 'RESET' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md={ 12 }>
              <Card className="main-card mb-3 p-4">
                <ReactTable
                  NoDataComponent={ () => <span></span> }
                  data={ props.recipientGroups.data }
                  columns={[
                    {
                      Header: Lang[ 'NAME' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'name',
                      width: 350,
                      Cell: ({value} ) => (
                        <>
                          <span>
                          { value[ props.data.languageReducer.userSettings.admin_panel_language ] }
                          </span>
                        </>
                      )
                    },
                    {
                      Header: Lang[ 'ACTIONS' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: "id",
                      Cell: ({row}) => (
                        <div>
                          <Button
                            id={ `sender-${ row.id }-view` }
                            className="mb-2 mr-2 btn-icon btn-icon-only"
                            color="primary"
                            onClick={ () => {
                              props.getSelectedRecipientGroup( row.id )
                              props.onChangeRecipientGroupHOC( 'showViewRecipientGroup', true )
                            } }
                            disabled={ !subscribedPackage } >
                            <i className="pe-7s-look"> </i>
                          </Button>
                          <UncontrolledTooltip
                            target={ `sender-${ row.id }-view` }
                            placement="top">
                            { Lang[ 'VIEW' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
                          </UncontrolledTooltip>
                        </div>
                      )
                    }
                  ]}
                  showPagination={ false }
                  defaultPageSize={ 10 } />
                  {
                    props.recipientGroups.data && props.recipientGroups.data.length > 0 && (
                      <ArkPagination
                        meta={ props.recipientGroups.meta }
                        onChangePage={ page => {
                          let tmp = {
                            page: page,
                            is_paginated: true
                          }
                          let tmpFilter = {}

                          props.searchParams.map( searchItem => {
                            if( !_.isEmpty( searchItem.param ) ){
                              tmpFilter = {
                                ...tmp,
                                [searchItem.value]: searchItem.value === 'name' ? { $like: `%${ searchItem.param }%` } : searchItem.param
                              }
                            }
                          })

                          let tmpString = convertSearchObjectToBase64( !_.isEmpty( tmpFilter ) ? { ...tmp, filter: tmpFilter } : tmp )
                          props.getAllRecipientGroup( tmpString )
                        }} />
                    )
                  }
              </Card>
            </Col>
          </Row>
        </Container>
        <Create
          {...props} />
        <Update
          {...props} />
        <View
          { ...props } />
      </ReactCSSTransitionGroup>
      { props.onLoadRecipientGroup && <LoadingOverlay/> }
    </>
  )
}

const mapStateToProps = state => ({ data: state })

export default compose(
  RecipientGroupHOC,
  connect( mapStateToProps ),
)( RecipientGroupListings )
